import React from 'react';
import {editCompanyTextAction} from "../../../../../../../services/company/api";
import Translate, {t} from "../../../../../../../components/Translate";
import config from "../../../../../../../config";

const TextActionSelector = ({features, client, user, textAction, setTextAction }) => {
    const handleSelectChange = (e) => {
        const value = e.target.value;
        setTextAction(value);
        editCompanyTextAction(client.id, value);
    };

    return (
        <div style={{padding: '5px', margin: '10px'}}>
            <h2 style={{fontSize: '16px', color: 'rgb(164, 173, 193)', marginBottom: '20px'}}>
                <Translate text={'chatbotActionsWhenUserTextIsUnknown'}/>
            </h2>
            <select
                value={textAction}
                onChange={handleSelectChange}
                style={{
                    display: 'block',
                    width: '100%',
                    marginTop: '10px',
                    backgroundColor: 'white',
                    border: '1px solid rgb(221, 221, 221)',
                    fontSize: '16px',
                    padding: '10px',
                    borderRadius: '10px',
                    marginBottom: '10px',
                }}
            >
                <option value={'CONNECT_TO_OPERATOR'}>{t({text: "connectToOperator", user})}</option>
                <option value={'SEND_I_DONT_KNOW_TEXT'}>{t({text: "sendIDontKnowText", user})}</option>
                <option value={'NOTHING_TO_DO'}>{t({text: "nothingToDo", user})}</option>
            </select>
        </div>
    );
};

export default TextActionSelector;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/TextActionSelector.jsx